import { Box, MantineLoaderComponent } from "@mantine/core";
import { forwardRef } from "react";

import nextcargoGif from "@/assets/images/carregando.svg";
import { cn } from "@/utils/cn";

export const NextCargoLoader: MantineLoaderComponent = forwardRef(({ className, ...props }, ref) => (
  <Box component="div" className={cn("w-sm md:w-md lg:w-lg", className)} {...props} ref={ref}>
    <img src={nextcargoGif} alt="load" loading="eager" />
  </Box>
));
NextCargoLoader.displayName = "NextCargoLoader";
